export default "__VITE_ASSET__BJcC7Azb__"